var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('el-tooltip',{staticStyle:{"cursor":"pointer"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n    "+_vm._s(_vm.tooltip)+"\n  ")]),_vm._v(" "),_c('el-tag',{attrs:{"type":_vm.type,"size":"small"},on:{"click":_vm.openTask}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.label)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12dd61dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/data-manager/components/TagStatus.vue
// module id = null
// module chunks = 